"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ceraso": {
    "2f4bc906": [{
      "hkey": "f0dacaaa",
      "slug": "ceraso",
      "name": "Ceraso",
      "primary": true,
      "skipSearch": false
    }],
    "campo": [{
      "hkey": "f0dacaaa",
      "slug": "ceraso",
      "name": "Ceraso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "44ca0e2f": [{
      "hkey": "f0dacaaa",
      "slug": "ceraso",
      "name": "Ceraso",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola": [{
      "hkey": "f0dacaaa",
      "slug": "ceraso",
      "name": "Ceraso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bde45323": [{
      "hkey": "f0dacaaa",
      "slug": "ceraso",
      "name": "Ceraso",
      "primary": true,
      "skipSearch": false
    }],
    "san-sumino": [{
      "hkey": "f0dacaaa",
      "slug": "ceraso",
      "name": "Ceraso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;